import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Code Code v1 Configuration Validator
 */
export const Code_Code_1_ConfigValidator = z.object({
    code: requiredString('Code is required'),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true;
        try {
            JSON.parse(val);
            return true;
        }
        catch {
            return false;
        }
    }, { error: 'Expected output must be empty or valid JSON' })
});
//# sourceMappingURL=code-code-1.js.map